export const sectionsOrder = [
  'medical_history',
  'physic_exploration',
  'supplementary_tests',
  'assessment',
  'treatment',
  'evolution'
]